import { ___ } from 'classes/Translation';


export default () => ({
	default: {
		_179: { label: `179 ${___('cm')}`, pole: '187', count: 6 },
		_150: { label: `149 ${___('cm')}`, pole: '158', count: 5 },
		_120: { label: `120 ${___('cm')}`, pole: '128', count: 4 },
	},
});